<script lang="ts">
  import Icon from 'shared/javascripts/components/Icon.svelte'
  import arrowLeft from 'shared/images/icons/arrow-left.svg'
  import closeIcon from 'shared/images/icons/close.svg'

  let {
    label,
    showBack,
    onBack,
    onClose,
  }: {
    label: string
    showBack: boolean
    onBack: () => void
    onClose: () => void
  } = $props()
</script>

<div class="mobileHeader">
  <button type="button" class="back" class:visible={showBack} onclick={onBack} aria-label="Zurück">
    <Icon src={arrowLeft} size="large" />
  </button>

  <span class="text">{label}</span>

  <button type="button" class="close" onclick={onClose} aria-label="Menü schließen">
    <Icon src={closeIcon} size="large" />
  </button>
</div>

<style>
  .mobileHeader {
    display: none;
  }

  @media (--header-medium-down) {
    .mobileHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--space-2);
      padding: var(--space-4) var(--space-6);
      background-color: var(--color-primary-bright);
      height: 70px;
    }
  }

  .back,
  .close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: none;
    color: var(--color-arsenic);
  }

  .back {
    visibility: hidden;
    opacity: 0;
  }

  .back.visible {
    visibility: visible;
    opacity: 1;
  }

  .text {
    flex: 1 1 auto;
    overflow: hidden;
    font-weight: var(--font-weight-semibold);
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
</style>
